import {
  FaTruck,
  FaShieldAlt,
  FaLock,
  FaHeadset,
  FaPlayCircle,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function HeroSection() {

   const navigate = useNavigate();
  const features = [
    {
      icon: <FaTruck />,
      title: "Easy Delivery",
      subtitle: "At Your Home",
      bg: "bg-yellow-400",
    },
    {
      icon: <FaShieldAlt />,
      title: "100% Original",
      subtitle: "Quality Products",
      bg: "bg-blue-950",
    },
    {
      icon: <FaLock />,
      title: "Secure Payment",
      subtitle: "100% Safe & Secure",
      bg: "bg-green-500",
    },
    {
      icon: <FaHeadset />,
      title: "24/7 Support",
      subtitle: "We're Here to Help",
      bg: "bg-purple-600",
    },
  ];

  return (
   <section className="w-full bg-[#f7f8fb] rounded-5xl overflow-hidden">
  <div className="grid lg:grid-cols-12 gap-4 p-4 md:p-6">
        {/* Left Content */}
        <div className="lg:col-span-4 flex flex-col justify-center">

          <div className="inline-block mb-5">
            <span className="bg-blue-100 text-blue-700 px-5 py-2 rounded-full text-sm font-medium">
              Shopping made easy
            </span>
          </div>

         <h1 className="text-3xl md:text-4xl xl:text-5xl font-bold leading-tight text-slate-900">
            Welcome to
            <br />
            GM <span className="text-yellow-500">Store</span>
          </h1>

          <p className="text-gray-600 mt-3">
            Discover amazing products at best prices.
            <br />
            Easy delivery at your home for all items.
          </p>

         <div className="flex flex-wrap gap-3 mt-5">
            <button  onClick={() => navigate("/shop")}  className="bg-blue-950 text-white px-8 py-4 rounded-xl font-semibold hover:scale-105 transition"  >
              Shop Now
            </button>

            <button onClick={() => navigate("/contact")} className="border-2 border-slate-300 px-8 py-4 rounded-xl font-semibold flex items-center gap-2 hover:bg-white transition">
              <FaPlayCircle />
              Contact Us
            </button>
          </div>

        </div>

        {/* Center Image */}
        <div className="lg:col-span-6 flex items-center justify-center">
          <img
            src="hero-11.png"
            alt="GM Store Hero"
            className="w-full max-w-xl max-h-[940px] object-contain"
          />
        </div>

        {/* Right Features */}
        <div className="lg:col-span-2 flex flex-col gap-4 justify-center">

          {features.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-3 shadow-sm border"
            >
              <div className="flex items-center gap-4">

                <div
                  className={`${item.bg} text-white w-12 h-12 rounded-full flex items-center justify-center text-lg`}
                >
                  {item.icon}
                </div>

                <div>
                  <h3 className="font-semibold text-slate-900">
                    {item.title}
                  </h3>

                  <p className="text-sm text-gray-500">
                    {item.subtitle}
                  </p>
                </div>

              </div>
            </div>
          ))}

        </div>

      </div>
    </section>
  );
}